import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { RefreshIcon } from '@src/components/icons/RefreshIcon';
import './UserGiftMessage.css';

const suggestions = ['surprise', 'magic', 'heart', 'kindness'];
export function UserGiftMessage({ value, onChange }: { value: string; onChange: (text: string, key?: string) => void }) {
  const { t, i18n } = useTranslation();
  const ru = i18n.language.startsWith('ru');
  const [index, setIndex] = useState(0);
  return <div className="user-gift-message">
    <label className="user-gift-message__label">
      <span>{ru ? 'Ваше пожелание получателям' : 'Your wish for the recipients'}</span>
      <input type="text" value={value} maxLength={300} onChange={event => onChange(event.target.value)} />
    </label>
    <button className="user-gift-message__shuffle" type="button" title={ru ? 'Другое пожелание' : 'Another wish'} aria-label={ru ? 'Другое пожелание' : 'Another wish'} onClick={() => { const next = (index + 1) % suggestions.length; setIndex(next); onChange(t(`boxGift.userGivingReplies.${suggestions[next]}`), suggestions[next]); }}><RefreshIcon /></button>
  </div>;
}
